import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import axios from "../../../services/interceptor/Interceptor";
import Config from "services/config/config";
import { handleValidateObj } from 'constants/objValues/objvalues';
import DivLayout from 'components/sales/divLayout/divLayout';
import "./pos.css";
import Images from 'assets/images/imageData';

const PosReplacement = ({
  match,
  getPosShipmentAndReasons,
  posRequirement,
  replaceOrReturnPos
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('');
  const [materialArray, setMaterialArray] = useState([]);
  const [duplicateData, setDuplicateData] = useState([]);
  const [isShow, setIsShow] = useState(true);
  const [details, setDetails] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [colSize, setColSize] = useState('col-md-6');
  const [amtCol,setAmtCol] = useState('col-md-6');
  const [colChechbox, setColChechbox] = useState('col-md-6');
  const [uiClass, setUiClass] = useState('input-check-box-ui-mobile');
  const [isRow, setIsRow] = useState('');
  const [isReturned, setIsReturned] = useState(false);
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])

  useEffect(() => {
    if(window.innerWidth !== undefined) {
      if(window.innerWidth > 796) {
        setColSize('col-md-3');
        setColChechbox('col-md-1');
        setAmtCol('col-md-2');
        setUiClass('input-check-box-ui');
        setIsRow('row');
      }
    }
  },[]);
    
  useEffect(() => {
    if (getPosShipmentAndReasons !== null && match.params.site_id && match.params.site_id == 0);
    (async () => {
      setIsLoading(true);
      await getPosShipmentAndReasons(match.params.site_id,1);
      setIsLoading(false);
    })();
  },[getPosShipmentAndReasons,match.params.site_id]);

  const handleAction = async () => {
    var isError,isError2 = false;
    materialArray.map((val) => {
      if(val.isReturnableChecked == true && !handleValidateObj(val)) {
        isError = true;
        isError2 = true;
      }
    });

    // if(!isError2) {
    //   toast.error('Please check atleast one material.');
    //   return false;
    // }
      
    if(isError) {
       toast.error('Please select serial number & reason against checked materials.');
       return false;
    }
    setDisabledBtn(true);
    setIsLoading(true);
    var payload = {
      'site_id':match.params.site_id,
      'type':1,
      'case':'replacement',
      'data': materialArray,
      'amount': amount
    }
    const res = await replaceOrReturnPos(payload);
    if (res === true) {
        toast.success('Item replaced.');
        setIsLoading(false);
        setTimeout(() => {
          window.location.reload()
      }, 4500);
    } else {
      toast.error('Failed');
      setDisabledBtn(false);
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
          <Button
            disabled={disabledBtn}
            className="btn btn-primary"
            onClick={() => handleAction()}
          >
            {localization.replaceItems}
          </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    if(posRequirement !== undefined) {
      if(posRequirement?.details != undefined && posRequirement?.details?.length > 0) {
          setReasons(posRequirement?.reasons);
          setIsReturned(posRequirement?.isReturned);
          const list = [...materialArray];
          var data = posRequirement.details;
          for(var i=0; i<data?.length; i++) {
            list[i] = {'id':data[i]?.id,'mat_id':data[i]?.material_id,'mat_name':data[i].material_name,'mat_code':data[i].material_code,'erp_serial_no':data[i].erp_serial_number,'old_serial_number':data[i].serial_number,'new_serial_number':'','reason':'','reason_value':'','amount':0,'isReturnableOrReplaceable':true,'isReturnableChecked':false};
          }
          setMaterialArray([...list]);
      }
    }
  },[posRequirement]);

  const fetchAmount = async (val,index,key) => {
    if(val !== undefined && val !== '') {
      const payload = {
         'data': val
      };
      const url = `${Config.installation.fetchAmountAgainstPos}`;
      const amount = await axios.post(url,payload); 
      let list = [...materialArray];
      if(amount && amount?.data) {
        list[index]['amount'] = amount?.data;
      } else {
        list[index]['amount'] = 0;
      }
      setMaterialArray([...list]);
    }
  }

  const handleValue = (val,key,index) => {
    if(val) {
      var flag = false;
      let list = [...materialArray];
      if(key === 'new_serial_number') {
        if(duplicateData.includes(val)) {
          toast.error('Serial number already selected');
          flag = false;
        } else { 
          duplicateData.push(val);
          flag = true;
        }
        //Remove from duplicate array
        if(list[index][key] !== undefined) {
          const position = duplicateData.indexOf(list[index][key]);
          if(position > -1) { 
             duplicateData.splice(position, 1); 
          }
        }

        if(list[index][key] == ' '){
          list[index][key] = (flag) ? val : '';
        } else{
          list[index][key] = (flag) ? val : ' ';
        }
      } else if(key === 'reason') { //console.log(val); return false;
        list[index][key] = val;
        list[index]['reason_value'] = 'NA';
      } else {
        list[index][key] = val;
      }  
      setMaterialArray([...list]);
    }
  }
  //console.log('ooo -- ' + duplicateData);

  const handleCheckBoxAction = (key,key2,index) => {
    //console.log('key ' + key + 'index ' + index);
    let list = [...materialArray];
    if(list[index][key]) {
        list[index][key] = false;
        list[index][key2] = true;
        list[index]['new_serial_number'] = '';
        list[index]['reason'] = '';
        list[index]['reason_value'] = '';
        list[index]['amount'] = 0;
    } else {
        list[index][key] = true;
        list[index][key2] = false;
    }
    setMaterialArray([...list]);
  } 

  useEffect(() => {
      if(materialArray?.length > 0 && materialArray !== undefined) {
          var amt = 0;
          materialArray.map((val) => {
            amt += parseFloat(val.amount);
          });
          setAmount(amt);
      }
  },[materialArray]);

  console.log('DATA >>> ' + JSON.stringify(materialArray));

  return (
    <Layout
      title={localization.POSReplacement}
      Buttons={(materialArray?.length > 0 && !isReturned) ? headerBtns : null}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/public-sites`}
      isLoading={isLoading}
    >
          <>
          {materialArray?.length > 0 && !isReturned ?
          <FormSection title={localization.POSReplacement}>
            <div className='text-center'>Total Amount : {amount}</div>
            <div className="panel-body" style={{'marginBottom':'3rem'}}>
            <>
              {materialArray && materialArray?.length > 0 && materialArray.map((item,key) => {
                return (
                <div className={`col-md-12 auto-w-100 auto-design-2 ` + isRow} key={key}>
                  <div className={colChechbox}>
                  <input className={uiClass} type="checkbox" checked={item['isReturnableChecked']} onClick={() => handleCheckBoxAction('isReturnableChecked','isReturnableOrReplaceable',key)} />
                  </div>  
                  <div className={colSize}>
                    <ConstantInput
                        label={localization.material}
                        isStarRequired={false}
                        disabled={true}
                        value={item['mat_name'] + ` (` + item['old_serial_number'] + `)`}
                        errorMsg={localization.isRequired}
                    />
                  </div>
                  <div className={colSize}>
                    <DropDownInput
                      name="serial_number"
                      data={item['erp_serial_no']}
                      label={localization.serialNo}
                      required={true}
                      isStarRequired={true}
                      errorMsg={localization.isRequired}
                      getIdValue={(val) => handleValue(val.id,'new_serial_number',key)}
                      value={item['new_serial_number']}
                      disabled={item['isReturnableOrReplaceable']}
                    />
                  </div>
                  <div className={colSize}>
                    <DropDownInput
                      name="reason"
                      data={reasons}
                      label={localization.reason}
                      required={true}
                      isStarRequired={true}
                      errorMsg={localization.isRequired}
                      getIdValue={(val) => {
                       handleValue(val,'reason',key);
                       fetchAmount(val,key,'reason');
                       }
                      }
                      value={item['reason_value']}
                      disabled={item['isReturnableOrReplaceable']}
                      multipule={true}
                    />
                  </div>
                  <div className={amtCol}>
                    <ConstantInput
                        label={localization.amount}
                        isStarRequired={false}
                        disabled={true}
                        value={item['amount']}
                        errorMsg={localization.isRequired}
                    />
                  </div>
                </div>
                )
              })
              }
             </>
            </div>
          </FormSection>
          :<div>
            <img src={Images?.NoData} alt="" width="100%" />
          </div>}
          </>
    </Layout>
  );
};
export default PosReplacement;
